import { Achievement } from '../models/achievement.model';

export const ACHIEVEMENTS: Achievement[] = [
  { icon: '🎓', number: 5000, displayNumber: '5,000+', label: 'Active Students' },
  { icon: '🏫', number: 150, displayNumber: '150+', label: 'Partner Schools' },
  { icon: '👨‍🏫', number: 300, displayNumber: '300+', label: 'Expert Teachers' },
  { icon: '🏆', number: 98, displayNumber: '98%', label: 'Success Rate' }
];
